"use client";

import { useState } from "react";
import Image from "next/image";
import { Play } from "lucide-react";

// Toont eerst het beeld van de uitzending, en laadt de speler pas als je erop
// tikt.
//
// Twee redenen. Je ziet meteen wáár het over gaat in plaats van een knop met
// tekst - op een wedstrijddag staat er "Alphen, zaterdag 15:30" op. En een
// YouTube-speler die niemand gebruikt kost op een telefoon langs de baan
// onnodig data; nu is het één afbeelding van zo'n 20 KB.
//
// Let op: YouTube geeft bij _live.jpg de posterafbeelding terug, geen bewegend
// beeld uit de lopende uitzending. Dat scheelt: het beeld verandert dus niet
// mee met wat er op de baan gebeurt.
export function VideoVoorbeeld({
  videoId,
  titel,
  live,
}: {
  videoId: string;
  titel: string;
  /** Er wordt op dit moment gereden; dan tonen we een live-aanduiding. */
  live?: boolean;
}) {
  const [spelen, setSpelen] = useState(false);

  if (spelen) {
    return (
      <div className="relative aspect-video w-full bg-black">
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
          title={titel}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 size-full"
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setSpelen(true)}
      aria-label={`${titel} afspelen`}
      className="group relative block aspect-video w-full overflow-hidden bg-black"
    >
      <Image
        src={`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`}
        alt=""
        fill
        sizes="(max-width: 448px) 100vw, 448px"
        className="object-cover"
      />

      <span className="absolute inset-0 bg-black/25 transition-colors group-hover:bg-black/10" />

      {live && (
        <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-primary px-2.5 py-1 font-display text-[0.65rem] font-black uppercase tracking-[0.14em] text-primary-foreground">
          <span className="relative flex size-2">
            <span className="absolute inline-flex size-full animate-ping rounded-full bg-black opacity-60 motion-reduce:animate-none" />
            <span className="relative inline-flex size-2 rounded-full bg-black" />
          </span>
          Live
        </span>
      )}

      <span className="absolute inset-0 flex items-center justify-center">
        <span className="flex size-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-transform group-hover:scale-105">
          <Play className="ml-0.5 size-7" fill="currentColor" aria-hidden />
        </span>
      </span>
    </button>
  );
}
